function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 53.44,
    height: 17.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.21375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 8.855,
    fontFamily: "Arial"
  }, "\n        Greenlee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.71,
    width: 53.44,
    height: 26.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.471666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 31.125,
    fontFamily: "Arial"
  }, "\n        La_Paz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44.54,
    width: 53.44,
    height: 53.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 71.15,
    fontFamily: "Arial"
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97.76,
    width: 53.44,
    height: 57.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 126.67500000000001,
    fontFamily: "Arial"
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 155.6,
    width: 53.44,
    height: 106.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 208.67,
    fontFamily: "Arial"
  }, "\n        Gila\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 261.74,
    width: 53.44,
    height: 116.3,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 319.89,
    fontFamily: "Arial"
  }, "\n        Apache\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 378.04,
    width: 53.44,
    height: 150.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 453.285,
    fontFamily: "Arial"
  }, "\n        Navajo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 528.53,
    width: 53.44,
    height: 171.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.72,
    y: 614.265,
    fontFamily: "Arial"
  }, "\n        Yuma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 0,
    width: 94.32,
    height: 112.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.474285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.6,
    y: 56.295,
    fontFamily: "Arial"
  }, "\n        Cochise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.77,
    y: 0,
    width: 116.14,
    height: 112.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.07375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.84,
    y: 56.295,
    fontFamily: "Arial"
  }, "\n        Coconino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.91,
    y: 0,
    width: 117.29,
    height: 112.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.555,
    y: 56.295,
    fontFamily: "Arial"
  }, "\n        Pinal\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.2,
    y: 0,
    width: 125.39,
    height: 112.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.895,
    y: 56.295,
    fontFamily: "Arial"
  }, "\n        Mohave\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.6,
    y: 0,
    width: 193.4,
    height: 112.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.084285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.3000000000001,
    y: 56.295,
    fontFamily: "Arial"
  }, "\n        Yavapai\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 112.59,
    width: 156.62,
    height: 587.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.75,
    y: 406.29499999999996,
    fontFamily: "Arial"
  }, "\n        Pima\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.06,
    y: 112.59,
    width: 489.94,
    height: 587.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 61.2425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.03,
    y: 406.29499999999996,
    fontFamily: "Arial"
  }, "\n        Maricopa\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.064bbffb3ade1e0efc4f37df695ebc73.svg";
export { ForwardRef as ReactComponent };